import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

export const Tooltip = styled(ReactTooltip)`
  background-color: ${(props) => props.theme.colors.blue} !important;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px #2f68f8 !important;
  color: #fff !important;
  opacity: 1 !important;
  padding: 4px 8px 4px !important;
  width: 256px !important;
  font-family: Inter !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  font-stretch: normal !important;
  font-style: normal !important;
  line-height: 1.33 !important;
  letter-spacing: normal !important;

  &::before {
    z-index: -1 !important;
  }

  &::after {
    background-color: ${(props) => props.theme.colors.blue} !important;
    border-top-color: ${(props) => props.theme.colors.blue} !important;
    z-index: -2 !important;
  }
`;
/*
  TODO: fix right positioned triangle color
*/

export const TooltipMain = styled(ReactTooltip)`
  min-width: 30px !important;
  max-width: 256px !important;
  min-height: 32px !important;
  padding: 6px 8px !important;
  text-align: left !important;
  text-decoration: none !important;
  word-wrap: break-word !important;
  border-radius: 4px !important;

  color: #182739 !important;
  background-color: #ffffff !important;
  box-shadow: 0 4px 12px 0 rgb(0 0 0 / 20%), 0 0 0 1px rgb(0 0 0 / 5%) !important;
  font-family: Inter !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  font-style: normal !important;
  font-stretch: normal !important;

  line-height: 1.33 !important;
  letter-spacing: normal !important;
  z-index: 2000 !important; // to beat the modal
  &::before {
    z-index: -1 !important;
  }

  &::after {
    z-index: -2 !important;
  }
`;
